import React, { useState, useEffect } from "react";
import { Fab, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PhoneIcon from "@mui/icons-material/Phone";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, IconButton } from "@mui/material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function LinkButtonFloting() {
  return (
    <Zoom in={true}>
      <Fab
        sx={{
          position: "fixed",
          right: 25,
          bottom: 160,
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <IconButton
          size="large"
          sx={{
            bgcolor: brandBlue,
            color: "#fff",
            p: 1.8,
            boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
            "&:hover": { bgcolor: "#000", color: "#fff" },
          }}
          href="tel:+971508517296"
          target="_blank"
        >
          <PhoneIcon fontSize="medium" />
        </IconButton>

        <IconButton
          size="large"
          sx={{
            bgcolor: "green",
            color: "#fff",
            p: 1.8,
            boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
            "&:hover": { bgcolor: "#0b7a0b", color: "#fff" },
          }}
          href="https://wa.me/+971505772284"
          target="_blank"
        >
          <WhatsAppIcon fontSize="medium" />
        </IconButton>

        <IconButton
          size="large"
          sx={{
            bgcolor: brandRed,
            color: "#fff",
            p: 1.8,
            boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
            "&:hover": { bgcolor: "#a00000" },
          }}
          href="mailto:info@burjalyarmouk.com"
          target="_blank"
        >
          <SupportAgentIcon fontSize="medium" />
        </IconButton>
      </Fab>
    </Zoom>
  );
}
